/**
 * «Төлөгдөөгүй · газар дээр» (C3 §7): a confirmed booking with a price
 * that nobody has paid and no online checkout — staff collect at the
 * venue. Booking status and payment state are two different things.
 */
export const UNPAID_AT_VENUE_LABEL = "Төлөгдөөгүй · газар дээр";

export function unpaidAtVenue(b: {
  status: string;
  paymentSummary?: { price: number | null; paid: number } | null;
  settings?: { paymentCheckout?: unknown } | null;
  /** The console list's flag for `settings.paymentCheckout`. */
  onlineCheckout?: boolean;
}): boolean {
  if (b.status !== "CONFIRMED") return false;
  const s = b.paymentSummary;
  if (!s || s.price === null || !(s.price > 0) || s.paid > 0) return false;
  return !(b.onlineCheckout || b.settings?.paymentCheckout);
}
